// import { useEffect } from "react";

// /**
//  * @param {String} node the parent node to house the visible object
//  * @param {Boolean} isVisible a boolean value to show if visible or not
//  * @param {Function} setVisibility a function to toggle the visibility state
//  */
// const useToggle = (node, isVisible, setVisibility) => {
//   const onHandleToggle = (e) => {
//     if (node && node.current?.contains(e.target)) {
//       return;
//     }
//     setVisibility(false);
//   };

//   useEffect(() => {    
//     window.addEventListener("click", onHandleToggle);
//     return () => {
//       window.removeEventListener("click", onHandleToggle);
//     };
//   }, []);
// };

// export default useToggle;







import { useEffect } from "react";

/**
 * @param {String} node the parent node to house the visible object
 * @param {Boolean} isVisible a boolean value to show if visible or not
 * @param {Function} setVisibility a function to toggle the visibility state
 */
const useToggle = (node, isVisible, setVisibility) => {
  const onHandleToggle = (e) => {
    if (node && node.current?.contains(e.target)) {
      return;
    }
    setVisibility(false);
  };

  useEffect(() => {
    if (isVisible) {
      document.addEventListener("click", onHandleToggle);
    } else {
      document.removeEventListener("click", onHandleToggle);
    }

    return () => {
      document.removeEventListener("click", onHandleToggle);
    };
  }, [isVisible]);
};

export default useToggle;


